
import { PageContainer } from "@/components/ui/page-container";
import { WelcomeBanner } from "@/components/services/layout/WelcomeBanner";
import { ServicesGrid } from "@/components/services/layout/ServicesGrid";
import { ProductsCarousel } from "@/components/services/layout/ProductsCarousel";
import { useState } from "react";
import { ResultsToolbar } from "@/components/services/layout/ResultsToolbar";

const Services = () => {
  const [activeTab, setActiveTab] = useState<string>('services');
  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");
  const [sortBy, setSortBy] = useState<string>("latest");
  
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  // Mock data for results count
  const resultCount = 25; // This could be dynamic based on actual data

  return (
    <PageContainer 
      variant="default"
      intensity="medium"
      className="py-0 px-0 container"
      fullWidth
    >
      <div className="space-y-3">
        <WelcomeBanner onTabChange={handleTabChange} />
        
        <div className="px-2 md:px-3">
          <div className="mb-4">
            <ResultsToolbar 
              resultCount={resultCount}
              sortBy={sortBy}
              setSortBy={setSortBy}
              viewMode={viewMode} 
              setViewMode={setViewMode}
            />
          </div>
          
          {activeTab === 'services' ? (
            <div className="animate-fade-in">
              <h2 className="text-lg font-bold mb-3 bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
                Nos Services
              </h2>
              <ServicesGrid viewMode={viewMode} />
            </div>
          ) : (
            <div className="animate-fade-in">
              <h2 className="text-lg font-bold mb-3 bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
                Nos Produits
              </h2>
              <ProductsCarousel />
            </div>
          )}
        </div>
      </div>
    </PageContainer>
  );
};

export default Services;
